var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 198,
    height: 145,
    viewBox: "0 0 198 145",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.375 109.748L172.969 5.15468C175.817 2.30677 179.156 0.882812 182.988 0.882812C186.819 0.882812 190.159 2.30677 193.009 5.15468C195.857 8.00468 197.281 11.3849 197.281 15.2953C197.281 19.2057 195.857 22.5859 193.009 25.4359L78.3969 140.286C75.5469 143.134 72.2063 144.558 68.375 144.558C64.5438 144.558 61.2031 143.134 58.3531 140.286L4.75314 86.6859C1.90522 83.8359 0.520847 80.4557 0.600013 76.5453C0.67918 72.6349 2.14272 69.2547 4.99064 66.4047C7.84064 63.5568 11.2208 62.1328 15.1313 62.1328C19.0417 62.1328 22.4219 63.5568 25.2719 66.4047L68.375 109.748Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.bac253b269eba1852523034ae9f66b4f.svg";
export { ForwardRef as ReactComponent };